<div class="server-down-container">
  <div class="error-content">
    <h1 class="error-title">Server Temporaneamente Non Disponibile</h1>

    <p class="error-message">Stiamo riscontrando difficoltà tecniche con i nostri server. Il nostro team è stato informato e sta lavorando per risolvere il problema.</p>

    <div class="error-details">
      <div class="detail-item"><strong>Stato:</strong> Servizio Non Disponibile (503)</div>
      <div class="detail-item"><strong>Ultimo Controllo:</strong> {{ lastChecked | date : 'medium' : 'it-IT' }}</div>
      @if (isRetrying) {
        <div class="detail-item"><strong>Prossimo Tentativo:</strong> {{ nextRetryIn }}s</div>
      }
    </div>

    <div class="action-buttons">
      <button class="retry-btn primary" (click)="retryConnection()" [disabled]="isRetrying">
        @if (!isRetrying) {
          <span>Riprova</span>
        }
        @if (isRetrying) {
          <span class="loading">
            <span class="spinner"></span>
            Riprovando...
          </span>
        }
      </button>

      <button class="refresh-btn secondary" (click)="refreshPage()">Aggiorna Pagina</button>
    </div>

    @if (autoRetryEnabled) {
      <div class="auto-retry">
        <div class="auto-retry-info">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M1 4v6h6" />
            <path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10" />
          </svg>
          Tentativo automatico tra {{ autoRetryCountdown }}s
        </div>
        <button class="disable-auto-retry" (click)="disableAutoRetry()">Disabilita tentativo automatico</button>
      </div>
    }

    <div class="help-section">
      <h3>Cosa puoi fare:</h3>
      <ul>
        <li>Aspetta qualche minuto e riprova</li>
        <li>Controlla la tua connessione internet</li>
        <li>Cancella la cache e i cookie del browser</li>
        <li>Contatta il supporto se il problema persiste</li>
      </ul>
    </div>

    <div class="contact-info">
      <p>Hai bisogno di assistenza immediata? <a href="mailto:helpdesk@kondorcs.it">Contatta il Supporto</a></p>
    </div>
  </div>
</div>
